import { v7 as uuidv7 } from "uuid";
import { create } from "zustand";

import { OKTAUserType } from "./useOKTAUserStore";

export interface UserToken {
  type: "device_id" | "aovisitor_id" | null;
  id: string | null;
}

/**
 * This global state storage is used for mySPH login user data.
 */
export interface UserVarStore {
  authenticatedUser: OKTAUserType | null;
  userToken: UserToken;
  deviceId: string | null;
  setAuthenticatedUser: (authenticatedUser: OKTAUserType | null) => void;
  setUserToken: (userToken: UserToken) => void;
}

let deviceId: string | null;

if (typeof window !== "undefined") {
  deviceId = localStorage.getItem("device_id");

  if (!deviceId) {
    deviceId = uuidv7();
    localStorage.setItem("device_id", deviceId);
  }
}

const useUserVarStore = create<UserVarStore>((set) => ({
  authenticatedUser: null,
  userToken: {
    type: "device_id",
    id: deviceId,
  },
  deviceId,
  setAuthenticatedUser: (authenticatedUser) => {
    set({ authenticatedUser });
  },
  setUserToken: (userToken) => {
    set({ userToken });
  },
}));

export default useUserVarStore;
